<template>
  <div
    class="card-information-discount"
    :style="`background: ${color}`"
    @click="openPopUp3dProject"
  >
    <div class="card-information-discount__title">
      3D проект
    </div>
    <div class="card-information-discount__message">
      Вы можете заказать бесплатный 3D проект детской комнаты
    </div>
    <div class="card-information-discount__signature">
      <img
        src="~/assets/img/logo/gray-signature.svg"
        alt="Миа София"
      />
    </div>

    <div class="card-information-discount__icon">
      <img
        src="~/assets/img/svg/common/arrow-top-right.svg"
        alt="стрелка в правый верхний угол"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCreateOrder3dProject } from '~/composables/useCreateOrder3dProject';

const props = defineProps({
  color: {
    type: String
  }
});

const {
  openCreateOrder3dProjectOpen
} = useCreateOrder3dProject();
const openPopUp3dProject = () => {
  openCreateOrder3dProjectOpen();
}
</script>

<style scoped lang="scss">
.card-information-discount {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  cursor: pointer;

  padding: 32px;
  border-radius: 20px;
  box-sizing: border-box;
  overflow: hidden;

  &:hover {
    .card-information-discount__title {
      text-decoration: underline;
    }
    .card-information-discount__signature {
      transform: translateX(-50%) scale(1.1)

    }
  }
}
.card-information-discount__title {
  color: #333;
  font-size: 24px;
  font-weight: 600;
  line-height: 120%;
}
.card-information-discount__message {
  margin-top: 16px;

  color: #000;
  font-size: 16px;
  line-height: 150%;
}
.card-information-discount__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 16px; right: 16px;
  width: 38px; height: 38px;
  border-radius: 10px;
  background-color: white;
}
.card-information-discount__signature {
  position: absolute;
  top: 20%; left: 50%;
  transform: translateX(-50%);
  opacity: 0.1;
  pointer-events: none;
  width: 100%;
  transition: transform 0.2s ease;

  img {
    width: 100%;
  }
}

@media (max-width: 639px) {
  .card-information-discount {
    height: 369px;
  }
}
</style>
